export const API_BASE_URL = "https://api.athelas.com/patient_portal";
